import React from "react";
import One from "../../Images/New/Process/1.svg";
import Two from "../../Images/New/Process/2.svg";
import Three from "../../Images/New/Process/3.svg";
import Four from "../../Images/New/Process/4.svg";
import Right from '../../Images/New/RightSvg.svg'

const Card = () => {
  const processes = [
    {
      image: One,
      title: "Data Input",
      description: [
        "Direct Data collection from the department site.",
        "Import Data Through Excel Sheets/ JSON",
        "Manual Data Entry in Software",
      ],
    },
    {
      image: Two,
      title: "Data Processing",
      description: [
        "Reconcile the data",
        "Pre-validation facility with multiple validations for identifying errors",
        "Return Summary view",
      ],
    },
    {
      image: Three,
      title: "Submit Return",
      description: [
        "Upload validated JSON file",
        "Import and view error JSON",
        "Submit the return and collect return status with ARN",
      ],
    },
    {
      image: Four,
      title: "Analysis Reports",
      description: [
        "Reports on Online available data",
        "Outward-Inward data summary & Reconciliation",
        "Input Tax Credit (ITC) Reports",
      ],
    },
  ];

  return (
    <div className="relative sm:flex justify-center space-y-8 sm:space-y-0 sm:space-x-3 px-3">
      {processes.map((process, index) => (
        <div
          key={index}
          className="border-2 w-[300px] p-5 group shadow-xl duration-200 hover:rounded-2xl hover:shadow-none hover:bg-[#7decc6] hover:bg-opacity-20"
        >
          <div>
            <img
              src={process.image}
              className="h-16 w-16 group-hover:bg-black duration-200 group-hover:rounded-full group-hover:p-3"
              alt=""
            />
          </div>
          <div>
            <p className="uppercase text-black text-2xl py-5 font-bold mb-0">
              {process.title}
            </p>
          </div>
          <div>
            <div className=" text-lg space-y-4 text-[#4b6175] font-medium list-none">
              {process.description.map((item, idx) => (
                <div className="flex items-start">
                  <img src={Right} className="mt-[6px] mr-2" alt="" />
                  <li key={idx}>{item}</li>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Card;
